import config from 'config';

function cdnAsset (path, base) {
  let map = ['a', 'b', 'c'];
  let key = path.length % 3;
  let cb = (typeof CACHE_BUSTER !== 'undefined') ? `?cb=${CACHE_BUSTER}` : ''; // CACHE_BUSTER defined in webpack

  switch (config['Environment']) {
    case 'Staging':
      base = `https://dev-${map[key]}.${base}`;
      break;
    case 'Production':
      base = `https://${map[key]}.${base}`;
      break;
  }
  return `${base}${path}${cb}`;
}

module.exports = {
  cdnTemplate: (path) => cdnAsset(path, config['TemplatesUrl']),
  jadeLocals: {
    cdn: { asset: (path) => cdnAsset(path, config['ImagesUrl']) }
  }
};



// WEBPACK FOOTER //
// ./source/client/cdn-preprocessor.js